
import React from 'react';
import { Check, Clock, X, HelpCircle } from "lucide-react";
import { RsvpStatus } from '../hooks/useRsvpStatus';

interface RsvpStatusIconProps {
  status?: RsvpStatus;
}

export const RsvpStatusIcon: React.FC<RsvpStatusIconProps> = ({ status }) => {
  switch (status) {
    case 'accepted':
      return <Check className="h-5 w-5 text-green-500" />;
    case 'declined':
      return <X className="h-5 w-5 text-red-500" />;
    case 'maybe':
      return <HelpCircle className="h-5 w-5 text-amber-500" />;
    default:
      return <Clock className="h-5 w-5 text-gray-400" />;
  }
};
